// Wording of the "Hourly Wage Billing" walkthrough. The twin of de/help/hourlywageinvoice.js — same
// steps, same claims.
export default {
  title: "[[HWI]]",
  section: {
    HourlywageinvoiceWizard: "Billing",
    ProjectDetail: "Project",
    SettingsOverview: "Notifications",
  },
  related: "Connections",
  // What the example pages show, for screen readers.
  image: {
    final: "Example of [[hwi:a/an]] [[hwi]] as a PDF",
    draft: "Example of an invoice draft as a PDF",
  },
  step: {
    // ── The wizard ─────────────────────────────────────────────────────────
    guide: {
      text: "The wizard works in three steps. First the project, then the period, then the search for the reports.",
    },
    project: {
      text: "Here you pick the project whose [[hwr.pl]] are billed. Below it are the dates, the address and the leading staff.",
    },
    range: {
      text: "The period narrows the search. The dots on the days show which days hold reports and how far those have been billed.",
    },
    legend: {
      text: "Red means no report of that day is billed. Yellow means only some of them are, green means all of them.",
    },
    search: {
      text: "The search fetches every [[hwr]] of the project in that period. The header says how many it found.",
    },
    table: {
      text: "One row per report, with its number, description, day of work and categories. A click on the row ticks the report.",
    },
    billed: {
      text: "The billed column says which report is already on an invoice. A half tick stands for a draft.",
    },
    mark: {
      text: "This menu ticks every report, only the ones that are not billed yet, or none at all.",
    },
    dialog: {
      text: "Billing opens this window for the ticked reports. Before that, Lewara checks whether every service in them has a price.",
    },
    warnings: {
      text: "This is where the window reports what stands out about the reports. A missing price locks billing until it is entered.",
    },
    options: {
      text: "A draft only writes a draft date on the reports, which still count as not billed. An own invoice number replaces the running one on the PDF and in the file name only.",
    },
    create: {
      text: "This button creates the invoice as a PDF and writes the billing date on every report. It also raises the project's invoice number.",
    },
    print: {
      text: "On the left the finished invoice with its number and prices, on the right the draft without either. Use the draft to check the quantities before you bill.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click plays it again.",
    },

    // ── Connections ────────────────────────────────────────────────────────
    "project-positions": {
      text: "The hourly rate per staff role is kept on the project. Without it, billing reports a missing price and stays locked.",
    },
    "project-prices": {
      text: "This is where the project's selling price for materials and machines is set. A surcharge needs the purchase price on the record.",
    },
    "project-reports": {
      text: "This is where the site writes its [[hwr.pl]]. Billing writes the date on each one that the wizard shows as billed.",
    },
    "settings-unbilled": {
      text: "The bell reports unbilled reports per project. How many days it waits before warning is set here.",
    },
  },
}
